import Icon from "../icons";

export default function Close({ onClick }) {
    return (
        <button type="button" onClick={onClick}>
            <Icon.Close />
        </button>
    )
}

Close.PropTypes = {

}
